import {
  ConsentName,
  Recruitment,
  SelectionBehavior,
  useConsentConfigs,
} from '@app/api';
import { Button } from '@app/core';
import { useFormikContext } from 'formik';
import moment from 'moment';
import { useCallback } from 'react';

const faker =
  process.env.NX_DEBUG_TOOLS === 'true'
    ? require('@faker-js/faker').fakerFR
    : null;

export const isFakerAvailable = !!faker;

export const FakerProfileButton = ({
  recruitment,
}: {
  recruitment?: Recruitment;
}) => {
  if (!isFakerAvailable) {
    return null;
  }

  const formik = useFormikContext();
  const fillForm = useCallback(() => {
    for (const crit of recruitment?.criteria || []) {
      if (
        crit.screenerCriterion ||
        crit.selectionBehavior === SelectionBehavior.NO_SELECTION
      ) {
        continue;
      }
      const list = crit.allowList;
      if (!list) {
        continue;
      }

      const index = Math.floor(Math.random() * list.length);
      const value = list[index];

      if (crit.fieldRef.startsWith('birthdate')) {
        const range = value as { min?: number; max?: number } | undefined;
        const max = range?.max || 100;
        const min = range?.min || 18;
        const gap = max - min;
        const age = Math.random() * gap + min;
        const date = moment().subtract(age, 'years').toDate();
        formik.setFieldValue(crit.fieldRef, date);
        continue;
      }
      formik.setFieldValue(crit.fieldRef, value);
    }
  }, [recruitment, formik]);

  return (
    <Button color="purple" small onClick={fillForm} type="button">
      Remplir
    </Button>
  );
};

export const FakerPersonalButton = () => {
  if (!isFakerAvailable) {
    return null;
  }

  const formik = useFormikContext();
  const configs = useConsentConfigs();

  const fillForm = useCallback(() => {
    const firstName = faker.person.firstName();
    const lastName = faker.person.lastName();
    formik.setFieldValue('firstName', firstName);
    formik.setFieldValue('lastName', lastName);
    formik.setFieldValue(
      'email',
      faker.internet.email({ firstName, lastName }),
    );
    formik.setFieldValue(
      'phoneNumber',
      faker.phone.number({
        style: 'international',
      }),
    );

    formik.setFieldValue('consents', [
      {
        documentId: configs[ConsentName.PARTICIPANT_PRIVACY].id,
        documentName: ConsentName.PARTICIPANT_PRIVACY,
        date: new Date(),
      },
      {
        documentId: configs[ConsentName.PARTICIPANT_TERMS].id,
        documentName: ConsentName.PARTICIPANT_TERMS,
        date: new Date(),
      },
    ]);
  }, [formik, configs]);

  return (
    <Button color="purple" small onClick={fillForm} type="button">
      Remplir
    </Button>
  );
};
